import type { RootState } from '../store';

export const selectAllGames = (state: RootState) => state.entities.games.items;

export const selectGameById = (gameId: string) => (state: RootState) =>
  state.entities.games.items.find((g) => g.id === gameId);

export const selectGameTags = (state: RootState) => state.entities.games.tags;

export const selectFavoriteGameIds = (state: RootState) => state.entities.games.favoriteIds;

export const selectIsGameFavorite = (gameId: string) => (state: RootState) =>
  state.entities.games.favoriteIds.includes(gameId);
